import Vue from 'vue'
import VueRouter from 'vue-router'
import panel from '../views/panel.vue'
import statistics from '../components/panel/statistics.vue'
import create from '../components/panel/create.vue'
import manage from '../components/panel/manage.vue'
import updateCategory from '../components/panel/updateCategory.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () =>
            import(/* webpackChunkName: "Home" */ '../views/Home.vue'),
    },
    {
        path: '/formMessage/:id',
        name: 'formMessage',
        beforeEnter: (to, from, next) => {
            setTimeout(() => {
                window.scrollTo(0, 0)
            }, 600)
            next()
        },
        component: () =>
            import(
                /* webpackChunkName: "formulario mensaje" */ '../views/formMessage.vue'
            ),
    },
    {
        path: '/formPay/:id',
        name: 'formPay',
        beforeEnter: (to, from, next) => {
            setTimeout(() => {
                window.scrollTo(0, 0)
            }, 600)
            next()
        },
        component: () =>
            import(
                /* webpackChunkName: "formulario pago" */ '../views/formPay.vue'
            ),
    },
    {
        path: '/navidad',
        name: 'navidad',
        component: () =>
            import(
                /* webpackChunkName: "navidad empresarial" */ '../views/navidad.vue'
            ),
    },
    {
        path: '/Approve',
        name: 'Approve',
        component: () =>
            import(
                /* webpackChunkName: "Pago aprovado" */ '../views/Approve.vue'
            ),
    },
    {
        path: '/Reject',
        name: 'Reject',
        component: () =>
            import(
                /* webpackChunkName: "Pago rechazado" */ '../views/Reject.vue'
            ),
    },
    {
        path: '/login',
        name: 'login',
        component: () =>
            import(
                /* webpackChunkName: "Pago rechazado" */ '../views/login.vue'
            ),
    },
    {
        path: '/panel',
        name: 'panel',
        component: panel,
        children: [
            { path: '', component: statistics },
            { path: 'create', component: create },
            { path: 'manage', component: manage },
            { path: 'updateCategory', component: updateCategory },
        ],
    },
    {
        path: '*',
        name: 'Not Found',
        component: () =>
            import(/* webpackChunkName: "404" */ '../views/NotFound.vue'),
    },
]

const router = new VueRouter({
    mode: 'history',
    routes,
})

export default router
